﻿class archdatadiff_aupcompare_section extends Tango.Component {
	widgetDidMount() {

		var _this = this;

		document.querySelectorAll("a[data-openDialogSection]").forEach(function (a) {
			var arg = a.getAttribute('data-openDialogSection');
			a.addEventListener("click", function () {
				_this.openDialogSection(arg = '' ? null : arg);
			});
		});
		document.querySelectorAll("a[data-clearsection]").forEach(function (a) {
			var arg = a.getAttribute('data-clearsection');
			a.addEventListener("click", function () {
				_this.clearSection(arg = '' ? null : arg);
			});
		});

		var chNode = document.querySelector("tr[data-rowid='Sum']");
		if (chNode != null && chNode.lastChild != null && chNode.lastChild.childNodes.length > 0) {
			chNode.lastChild.childNodes[0].remove()
			document.querySelector("tr[data-rowid='Sum']").lastChild.classList = "";
		}
	}

	onResult(state) {
		if (state == 0) {
			const sd = document.getElementById(this.props.selectDialogID);
			dialog.close(sd);
			return false;
		}
	}

	removeRowSectonReason(id) {
		var row = document.querySelector("tr[temp-id='" + id + "0" + "0']");
		row.setAttribute("isDeleted", 1);
		row.setAttribute("style", "visibility:collapse");
	}

	openDialogSection(field) {
		if (field == null && document.querySelectorAll("table[data-table-sectiondata] tr[class*='checked']").length == 0) {
			alert('Не выбраны часовки для установки причины');
			return;
		}

		function addTempRow(sd, reasonid, caseNumber, isti, istp, needRemove, firstOpen, tiintersectsection) {
			const w = new Tango.HtmlWriter();

			var tableRef = sd.querySelector("table[data-id=tablecurrentreasons]");
			//if (!firstOpen) {
			//	var isAddSectionReason = tableRef.querySelectorAll("tr[reasonsection='true'][isdeleted='0']").length;
			//	if (isAddSectionReason) {
			//		alert("В данном часе уже установлена причина! Для Сечения не допускается установка более одной причины!");
			//		return;
			//	}
			//}

			//if (!firstOpen) {
			//	var isAddSectionReason = tableRef.querySelectorAll("tr[rowti='1'][isdeleted='0'][reasonid='5']").length;
			//	if (isAddSectionReason && reasonid==5) {
			//		alert("Причина уже установлена!");
			//		return;
			//	}
			//}
			let isFiveReasonTI = false;
			if (!firstOpen) {
				var isAddSectionReason = tableRef.querySelectorAll("tr[rowti='1'][isdeleted='0'][reasonid='5']").length;
				if (isAddSectionReason && reasonid == 5) {
					isFiveReasonTI = true;
					//return;
				}
			}

			var row = document.querySelector("tr[temp-id='temp_id_" + reasonid + caseNumber + isti + istp + "']")
			if (row != null) {
				row.removeAttribute("style");
				row.setAttribute("isDeleted", 0)
			}
			else {
				var newRow = tableRef.insertRow(0);
				newRow.setAttribute("rowti", isti);
				newRow.setAttribute("rowtp", istp);
				newRow.setAttribute("temp-id", "temp_id_" + reasonid + caseNumber + isti + istp);
				newRow.setAttribute("isDeleted", 0);
				newRow.setAttribute("reasonid", reasonid);
				newRow.setAttribute("tiintersectsection", tiintersectsection);
				if (firstOpen)
					newRow.setAttribute("add", "0");
				else {
					newRow.setAttribute("add", "1");
					if (isFiveReasonTI)
						newRow.setAttribute("viewInGrid", "0");
					else
						newRow.setAttribute("viewInGrid", "1");
				}
				var cellTextInfo = newRow.insertCell(0);

				var textInfo = document.createElement("span");
				if (isti)
					textInfo.innerHTML = "Установлено замещение для ТИ";
				else if (istp)
					textInfo.innerHTML = "Установлено замещение для ТП (в Журнале Алгоритмов)"
				else
					textInfo.innerHTML = "Установлено для сечения";
				cellTextInfo.appendChild(textInfo);

				var cellReason = newRow.insertCell(1);
				var divReason = document.createElement("div");
				divReason.classList.add("archdatareasoncol");
				divReason.classList.add("archdatareasoncol_" + reasonid);
				divReason.innerHTML = reasonid;
				cellReason.appendChild(divReason);

				var divCaseNumber = document.createElement("div");
				divCaseNumber.classList.add("archdatareasoncaseicon");
				divCaseNumber.setAttribute("rowti", isti);
				divCaseNumber.setAttribute("rowtp", istp);
				divCaseNumber.innerHTML = caseNumber;
				var cellCase = newRow.insertCell(2);
				cellCase.appendChild(divCaseNumber);

				var cellCRemove = newRow.insertCell(3);

				var tegA = document.createElement("a");
				//tegA.setAttribute("href", "#");
				tegA.setAttribute("style", "float: right; margin-top: 2px");
				if (needRemove) {
					newRow.setAttribute("reasonsection", "true");
					tegA.appendChild(w.Icon("delete"));
					tegA.addEventListener("click", function () {
						_this.removeRowSectonReason("temp_id_" + reasonid + caseNumber);
					});
				}

				cellCRemove.appendChild(tegA);
			}
		}

		const sd = document.getElementById(this.props.selectDialogID);

		if (sd === null)
			return false;

		if (window.innerWidth > 800)
			sd.style.width = window.innerWidth - 500 + 'px';
		else
			sd.style.width = 500 + 'px';

		//sd.querySelectorAll("tr[class*='reasonsselect-level2']").forEach(function (cl) {
		//	if (!cl.classList.contains("hide"))
		//		cl.classList.add("hide");
		//});

		dialog.open(sd);
		sd.querySelector("table[data-id=tablecurrentreasons]").querySelectorAll("tr").forEach(function (row) {
			var p = row.parentNode;
			p.removeChild(row);
		});
		document.querySelector("input[name='fieldtosave']").value = field;
		var isOnlyReasonForTI = false;
		var names = [];


		if (field != null) {
			// Пиктограмма редактирования: только выбранная строка, чек-боксы игнорируются
			names.push(field);
		} else {
			// Кнопка «Действия»: все отмеченные чек-боксами строки
			document.querySelectorAll("table[data-table-sectiondata] tr[class*='checked']").forEach(function (el) {
				var container = el.querySelector("div[data-id*='container']");
				if (container != null)
					names.push(container.getAttribute("data-id").replace("_container", ""));
			});
		}

		names.forEach(function (name) {
			document.querySelectorAll("div[data-id='" + name + "_r_s']").forEach(function (div) {
				var caseid = div.getAttribute("data-caseid");
				var reasonid = div.getAttribute("data-reasonid");
				var tiintersectsection = div.getAttribute("data-tiintersectsection");
				addTempRow(sd, reasonid, caseid, 0, 0, true, true, tiintersectsection);
			});
			document.querySelectorAll("div[data-id='" + name + "_r_ti']").forEach(function (div) {
				var caseid = div.getAttribute("data-caseid");
				var reasonid = div.getAttribute("data-reasonid");
				var tiintersectsection = div.getAttribute("data-tiintersectsection");
				addTempRow(sd, reasonid, caseid, 1, 0, false, true, tiintersectsection);
				//isOnlyReasonForTI = true;
			});
			document.querySelectorAll("div[data-id='" + name + "_r_tp']").forEach(function (div) {
				var caseid = div.getAttribute("data-caseid");
				var reasonid = div.getAttribute("data-reasonid");
				var tiintersectsection = div.getAttribute("data-tiintersectsection");
				addTempRow(sd, reasonid, caseid, 0, 1, false, true, tiintersectsection);
			});
		});

		//if (sd.querySelector("tr[tiintersectsection='True'][rowti='1'][notselectionfive='true']") != null) {
		//	sd.querySelector("table[data-treasonsselect]").classList.add("hide")
		//	sd.querySelector("div[data-messageblock]").classList.remove("hide")
		//}
		//else {
		//	sd.querySelector("table[data-treasonsselect]").classList.remove("hide")
		//	sd.querySelector("div[data-messageblock]").classList.add("hide")
		//}

		sd.querySelectorAll("tr[data-reasonid] a").forEach(function (a) {
			a.onclick = function () {
				const isCollapsed = this.firstChild.classList.contains('icon-collapsed');
				if (isCollapsed) {
					this.childNodes[0].classList.remove('icon-collapsed');
					this.childNodes[0].classList.add('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.remove('hide');
					});
				}
				else {
					this.childNodes[0].classList.add('icon-collapsed');
					this.childNodes[0].classList.remove('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.add('hide');
					});
				}
			}
		});
		document.querySelector("table[data-treasonsselect]").querySelectorAll("tr[data-onlywithti='false']").forEach(function (tr) {
			tr.style.visibility = isOnlyReasonForTI == false ? "visible" : "hidden";
		});
		var _this = this;
		sd.querySelectorAll(".archdatareasoncaseicon").forEach(function (div) {
			const td = div.parentElement;
			const tr = td.parentElement;
			td.onclick = function () {
				if (div.getAttribute("rowti") == null && div.getAttribute("rowtp") == null) {
					var reasonid = tr.getAttribute("data-reasonid");
					var caseNumber = div.innerHTML;
					addTempRow(sd, reasonid, caseNumber, 0, 0, true, false);
					
				}
			};
		});

		return false;
	}
	saveToTable() {
		const sd = document.getElementById(this.props.selectDialogID);
		var table = sd.querySelector("table[data-id='tablecurrentreasons']");
		//if (table.querySelectorAll("tr[rowti='0'][isDeleted='0']").length > 1) {
		//	alert("Установлено более 1 причины для сечения!");
		//	return;
		//}
		var _this = this;
		var fieldtosave = document.querySelector("input[name=fieldtosave]").value;
		var names = [];
		if (fieldtosave == null || fieldtosave == '') {
			document.querySelectorAll("tr[class*='checked']").forEach(function (el) {
				var container = el.querySelector("div[data-id*='container']");
				if (container != null) {
					var name = container.getAttribute("data-id").replace("_container", "");
					names.push(name);
				}
			});
		}
		else {
			names.push(fieldtosave);
		}
		names.forEach(function (name) {

			table.querySelectorAll("tr[rowti='0']").forEach(function (el) {
				var reasonNumberDIV = el.children[1].querySelector("div");
				var caseNumberDIV = el.children[2].querySelector("div");
				var isDeleted = el.getAttribute("isDeleted");
				var isAdd = el.getAttribute("add");
				var isView = el.getAttribute("viewInGrid");
				
				if (isDeleted == 1) {
					var divDel = document.querySelector("div[data-id='" + name + "_r_s'][data-reasonid='" + reasonNumberDIV.innerHTML + "'][data-caseid='" + caseNumberDIV.innerHTML + "']");
					if (divDel != null) {
						var divDelParent = divDel.parentElement;
						divDelParent.removeChild(divDel);
					}

					if (document.querySelectorAll("div[data-id='" + name + "_r_s'][data-reasonid='" + reasonNumberDIV.innerHTML + "']").length == 0) {
						divDel = document.querySelector("div[data-id='" + name + "_saggr'][data-reasonid='" + reasonNumberDIV.innerHTML + "']");
						if (divDel != null) {
							divDelParent = divDel.parentElement;
							divDelParent.removeChild(divDel);
						}
					}
					
				}

				var fName = name + "_" + reasonNumberDIV.innerHTML + "_" + caseNumberDIV.innerHTML;

				if (isDeleted == 1) {
					if (_this.state.diffjson[fName]) {
						if (_this.state.diffjson[fName].archDataDiff_ID == 0)
							_this.state.diffjson[fName].archDataDiff_ID = -1000;
						else
							_this.state.diffjson[fName].archDataDiff_ID = _this.state.diffjson[fName].archDataDiff_ID * (-1);
					}
				}

				if (isAdd == 1) {

					if (document.querySelectorAll("div[data-id='" + name + "_r_s'][data-reasonid='" + reasonNumberDIV.innerHTML + "'][data-caseid='" + caseNumberDIV.innerHTML + "']").length == 0) {
						var add = false;
						document.querySelectorAll("td[data-td*='td_" + name + "']").forEach(function (el1) {
							if (el1.childNodes.length == 0) {
								const check = document.querySelector("div[data-id*='" + name + "_saggr'][data-reasonid='" + reasonNumberDIV.innerHTML + "']")
								if (check == null && add == false) {

									if (isView == 1) {
										const adddivsaggr = document.createElement("div");
										adddivsaggr.innerHTML = reasonNumberDIV.innerHTML;
										adddivsaggr.classList.add("archdatareasoncol");
										adddivsaggr.classList.add("archdatareasoncol_" + reasonNumberDIV.innerHTML);
										adddivsaggr.setAttribute("data-reasonid", reasonNumberDIV.innerHTML);
										adddivsaggr.setAttribute("data-id", name + "_saggr");
										el1.appendChild(adddivsaggr);

										
									}
									add == true;
								}

								const p = el1.parentElement.parentElement.parentElement.parentElement;
								if (p.querySelector("div[data-id='" + name + "_r_s'][data-reasonid='" + reasonNumberDIV.innerHTML + "'][data-caseid='" + caseNumberDIV.innerHTML + "']") == null) {
									const adddiv = document.createElement("div");
									adddiv.innerHTML = reasonNumberDIV.innerHTML;
									adddiv.classList.add("archdatareasoncol");
									adddiv.classList.add("archdatareasoncol_" + reasonNumberDIV.innerHTML);
									adddiv.classList.add("hide");
									adddiv.setAttribute("data-reasonid", reasonNumberDIV.innerHTML);
									adddiv.setAttribute("data-id", name + "_r_s");
									adddiv.setAttribute("data-caseid", caseNumberDIV.innerHTML);
									p.appendChild(adddiv);
								}
							}
						});

						

						if (!_this.state.diffjson[fName])
							_this.state.diffjson[fName] = {};
						_this.state.diffjson[fName].archDataDiffReasonNumber = reasonNumberDIV.innerHTML;
						_this.state.diffjson[fName].archDataDiffReason_ID = reasonNumberDIV.innerHTML;
						_this.state.diffjson[fName].archDataDiffReasonCaseNumber = caseNumberDIV.innerHTML;
						_this.state.diffjson[fName].archDataDiffReasonCase_ID = caseNumberDIV.innerHTML;
						_this.state.diffjson[fName].archDataDiff_ID = 0;
					}
				}
			});

			if (document.querySelectorAll("div[data-id='" + name + "_r_s']").length > 0 && document.querySelector("a[data-clearsection='" + name + "']")!=null)
				document.querySelector("a[data-clearsection='" + name + "']").classList.remove("hide");
			else
				document.querySelector("a[data-clearsection='" + name + "']").classList.add("hide");


			const reasons = [];


			document.querySelectorAll("td[data-td*='td_" + name + "_']").forEach(function (el) {
				if (el.childNodes.length > 0) {
					var reasonid = el.childNodes[0].getAttribute("data-reasonid");
					reasons.push(reasonid);
					el.removeChild(el.childNodes[0]);
				}
			});

			reasons.sort();

			let i = 1;
			reasons.forEach(function (el) {
				var adddivsaggr = document.createElement("div");
				adddivsaggr.innerHTML = el;
				adddivsaggr.classList.add("archdatareasoncol");
				adddivsaggr.classList.add("archdatareasoncol_" + el);
				adddivsaggr.setAttribute("data-reasonid", el);
				adddivsaggr.setAttribute("data-id", name + "_saggr");
				adddivsaggr.style.marginTop="2px";


				document.querySelector("td[data-td*='td_" + name + "_" + i + "']").appendChild(adddivsaggr);
				i = i + 1;
			});


			//table.querySelectorAll("tr[rowti='0']").forEach(function (el) {
			//	var reasonNumberDIV = el.children[1].querySelector("div");
			//	var caseNumberDIV = el.children[2].querySelector("div");
			//	var isDeleted = el.getAttribute("isDeleted");
			//	var isAdd = el.getAttribute("add");

			//	var isFind = false;
			//	var countFind = 0;
			//	var conteinercield = document.querySelector("div[data-id='" + name + "_container']");
			//	//var isFirstReason = conteinercield.querySelector("div[data-id='" + name + "_tiaggr']");

			//	conteinercield.querySelectorAll("div").forEach(function (div) {
			//		if (div.getAttribute("data-reasonid") == reasonNumberDIV.innerHTML && div.getAttribute("data-caseid") == caseNumberDIV.innerHTML) {
			//			isFind = true;
			//		}
			//	});

			//	var fName = name + "_" + reasonNumberDIV.innerHTML + "_" + caseNumberDIV.innerHTML;

			//	if (isFind == false && (isDeleted == null || isDeleted == 0)) {
			//		var adddiv = document.createElement("div");
			//		adddiv.innerHTML = reasonNumberDIV.innerHTML;
			//		adddiv.classList.add("archdatareasoncol");
			//		adddiv.classList.add("archdatareasoncol_" + reasonNumberDIV.innerHTML);
			//		adddiv.setAttribute("data-reasonid", reasonNumberDIV.innerHTML);
			//		adddiv.setAttribute("data-id", name + "_r_s");
			//		adddiv.setAttribute("data-caseid", caseNumberDIV.innerHTML);
			//		//if (isFirstReason == null)
			//		//	adddiv.style.marginLeft = "0px";

			//		conteinercield.appendChild(adddiv);

			//		if (!_this.state.diffjson[fName])
			//			_this.state.diffjson[fName] = {};
			//		_this.state.diffjson[fName].archDataDiffReasonNumber = reasonNumberDIV.innerHTML;
			//		_this.state.diffjson[fName].archDataDiffReason_ID = reasonNumberDIV.innerHTML;
			//		_this.state.diffjson[fName].archDataDiffReasonCaseNumber = caseNumberDIV.innerHTML;
			//		_this.state.diffjson[fName].archDataDiffReasonCase_ID = caseNumberDIV.innerHTML;
			//		_this.state.diffjson[fName].archDataDiff_ID = 0;
			//		countFind = countFind + 1;
			//	}
			//	else if (isFind == true && isDeleted == 1) {
			//		var divDel = document.querySelector("div[data-id='" + name + "_r_s'][data-reasonid='" + reasonNumberDIV.innerHTML + "'][data-caseid='" + caseNumberDIV.innerHTML + "']");
			//		var divDelParent = divDel.parentElement;
			//		divDelParent.removeChild(divDel);

			//		if (document.querySelectorAll("div[data-id='" + name + "_r_s'][data-reasonid='" + reasonNumberDIV.innerHTML + "']").length == 0) {
			//			divDel = document.querySelector("div[data-id='" + name + "_saggr'][data-reasonid='" + reasonNumberDIV.innerHTML + "']");
			//			divDelParent = divDel.parentElement;
			//			divDelParent.removeChild(divDel);
			//		}

			//		if (_this.state.diffjson[fName]) {
			//			if (_this.state.diffjson[fName].archDataDiff_ID == 0)
			//				_this.state.diffjson[fName].archDataDiff_ID = -1000;
			//			else
			//				_this.state.diffjson[fName].archDataDiff_ID = _this.state.diffjson[fName].archDataDiff_ID * (-1);

			//		}
			//	}

			//	if (document.querySelectorAll("div[data-id='" + name + "_r_s']").length > 0)
			//		document.querySelector("a[data-clearsection='" + name + "']").classList.remove("hide");
			//	else
			//		document.querySelector("a[data-clearsection='" + name + "']").classList.add("hide");

			//	//var rowAllDiff = document.querySelector("td[data-alldiff='" + name + "_rs']");
			//	//var containerDiffs = document.querySelector("div[data-id='" + name + "_container']")
			//	//if (rowAllDiff != null) {
			//	//	if (containerDiffs.childNodes.length > 0)
			//	//		containerDiffs.parentElement.style.backgroundColor = null;
			//	//	else
			//	//		containerDiffs.parentElement.style.backgroundColor = "#F08080";
			//	//}

			//	//if (_this.state.allcurrentdiff[name] == null)
			//	//	_this.state.allcurrentdiff[name] = {};

			//	//if (document.querySelector("div[data-id='" + name + "_container']").childElementCount > 0) {
			//	//	_this.state.allcurrentdiff[name].isNotEmpty = true;
			//	//	_this.state.allcurrentdiff[name].isSaved = false;
			//	//}
			//	//else {
			//	//	_this.state.allcurrentdiff[name].isNotEmpty = false;
			//	//	_this.state.allcurrentdiff[name].isSaved = false;
			//	//}
			//});
			console.log(name);
			
			//var sectionReason = document.querySelector("div[data-id='" + name + "_r_s']");
			//var isFirstReason = document.querySelector("div[data-id='" + name + "_container']").querySelector("div[data-id='" + name + "_tiaggr'][data-reasonid='1']");
			//var isTwoReason = document.querySelector("div[data-id='" + name + "_container']").querySelector("div[data-id='" + name + "_r_s'][data-reasonid='2']");
			//var isFiveReason = document.querySelector("div[data-id='" + name + "_container']").querySelector("div[data-id='" + name + "_tiaggr'][data-reasonid='5']");
			//if (isFirstReason != null && sectionReason != null) {
			//	console.log(sectionReason.getAttribute("data-reasonid"));
			//	var sectionReason = sectionReason.getAttribute("data-reasonid");
			//	if ((sectionReason == "3" || sectionReason == "4" || sectionReason == "5") && isFirstReason != null) {
			//		isFirstReason.classList.replace("archdatareasoncol_" + isFirstReason.innerHTML, "archdatareasoncol_tigray");
			//		if (isFiveReason != null)
			//			isFiveReason.classList.replace("archdatareasoncol_" + isFiveReason.innerHTML, "archdatareasoncol_tigray");
			//	}
			//	else if (isTwoReason != null && isFirstReason != null) {
			//		isFirstReason.classList.replace("archdatareasoncol_tigray", "archdatareasoncol_" + isFirstReason.innerHTML);
			//	}
			//	//else
			//	//	isFirstReason.classList.replace("archdatareasoncol_" + + isFirstReason.innerHTML, "archdatareasoncol_tigray");

			//}
			//else if (isFirstReason != null && isFiveReason == null) {
			//	isFirstReason.classList.replace("archdatareasoncol_tigray", "archdatareasoncol_" + isFirstReason.innerHTML);
			//}
			//else if (isFirstReason != null && isFiveReason != null) {
			//	isFirstReason.classList.replace("archdatareasoncol_" + isFirstReason.innerHTML, "archdatareasoncol_tigray");
			//	isFiveReason.classList.replace("archdatareasoncol_tigray", "archdatareasoncol_" + isFiveReason.innerHTML);
			//	isFiveReason.classList.remove("hide");
			//}
			//else if (isFiveReason != null) {
			//	isFiveReason.classList.replace("archdatareasoncol_tigray", "archdatareasoncol_" + isFiveReason.innerHTML);
			//	isFiveReason.classList.remove("hide");
			//}

		});

		document.querySelector("input[name='diffjsonsection']").value = encodeURIComponent(JSON.stringify(_this.state.diffjson))
		document.querySelector("input[name='allcurrentdiff']").value = encodeURIComponent(JSON.stringify(_this.state.allcurrentdiff))
		sd.querySelectorAll("tr[class*='reasonsselect-level2']").forEach(function (cl) {
			if (!cl.classList.contains("hide"))
				cl.classList.add("hide");
		});

		document.querySelectorAll("tr[class*='reasonsselect-level1']").forEach(function (cl) {
			cl.querySelector("i[class*='icon']").classList.replace("icon-expanded", "icon-collapsed");
		});

		dialog.close(sd);
		_this.calcReasons();
	}
	clearSection(field) {
		var names = [];
		if (field == null) {
			var allSelected = document.querySelectorAll("table[data-table-sectiondata] tr[class*='checked']");
			if (allSelected.length == 0) {
				alert('Не выбраны часовки для очистки причины');
				return;
			}

			allSelected.forEach(function (el) {
				var container = el.querySelector("div[data-id*='container']");
				if (container != null) {
					var name = container.getAttribute("data-id").replace("_container", "");
					names.push(name);
				}
			});
		}
		else {
			names.push(field);
		}
		var _this = this;
		if (_this.state != null) {
			names.forEach(function (name) {
				console.log("clear with name: " + name)
				document.querySelectorAll("div[data-id='" + name + "_r_s']").forEach(function (div) {
					var reasonid = div.getAttribute("data-reasonid");
					var caseid = div.getAttribute("data-caseid");
					var fieldName = name + "_" + reasonid + "_" + caseid;

					if (_this.state.diffjson[fieldName]) {
						if (_this.state.diffjson[fieldName].archDataDiff_ID > 0)
							_this.state.diffjson[fieldName].archDataDiff_ID = _this.state.diffjson[fieldName].archDataDiff_ID * (-1);
						else if (_this.state.diffjson[fieldName].archDataDiff_ID == 0)
							_this.state.diffjson[fieldName] = null;
					}

					var p = div.parentElement;
					p.removeChild(div);
				});

				document.querySelectorAll("div[data-id='" + name + "_saggr']").forEach(function (div) {
					var reasonid = div.getAttribute("data-reasonid");
					var caseid = div.getAttribute("data-caseid");

					var p = div.parentElement;
					p.removeChild(div);
				});

				var rowAllDiff = document.querySelector("td[data-alldiff='" + name + "_rs']");
				if (rowAllDiff != null && rowAllDiff.getAttribute("data-alldiff") !== null && document.querySelector("div[data-id='" + name + "_tiaggr']") == null)
					document.querySelector("td[data-alldiff='" + name + "_rs']").style.backgroundColor = "#F08080";

				if (_this.state.allcurrentdiff[name] == null)
					_this.state.allcurrentdiff[name] = {};

				if (document.querySelector("div[data-id='" + name + "_container']").childElementCount > 0) {
					_this.state.allcurrentdiff[name].isNotEmpty = true;
					_this.state.allcurrentdiff[name].isSaved = false;
				}
				else {
					_this.state.allcurrentdiff[name].isNotEmpty = false;
					_this.state.allcurrentdiff[name].isSaved = false;
				}
				//var isFirstReason = document.querySelector("div[data-id='" + name + "_container']").querySelector("div[data-id='" + name + "_tiaggr'][data-reasonid='1']");
				//var isFiveReason = document.querySelector("div[data-id='" + name + "_container']").querySelector("div[data-id='" + name + "_tiaggr'][data-reasonid='5']");
				//if (isFirstReason != null && isFiveReason == null) {
				//	isFirstReason.classList.replace("archdatareasoncol_tigray", "archdatareasoncol_" + isFirstReason.innerHTML);
				//}
				//else if (isFirstReason != null && isFiveReason != null) {
				//	isFirstReason.classList.replace("archdatareasoncol_" + isFirstReason.innerHTML, "archdatareasoncol_tigray");
				//	isFiveReason.classList.replace("archdatareasoncol_tigray", "archdatareasoncol_" + isFiveReason.innerHTML);
				//	isFiveReason.classList.remove("hide");
				//}
				//else if (isFiveReason != null && isFirstReason == null) {
				//	isFiveReason.classList.remove("hide");
				//	isFiveReason.classList.replace("archdatareasoncol_tigray", "archdatareasoncol_" + isFiveReason.innerHTML);
				//}

				var f = document.querySelector("a[data-clearsection='" + name + "']")
				if (f != null)
					f.classList.add("hide");
				document.querySelector("input[name='diffjsonsection']").value = encodeURIComponent(JSON.stringify(_this.state.diffjson))
				document.querySelector("input[name='allcurrentdiff']").value = encodeURIComponent(JSON.stringify(_this.state.allcurrentdiff))
			});
		}
		_this.calcReasons();
	}

	getReasons(values) {
		const contains = function (val1, val2, val3) {
			return values.indexOf(val1.toString()) >= 0 &&
				(val2 == undefined || values.indexOf(val2.toString()) >= 0) && 
				(val3 == undefined || values.indexOf(val3.toString()) >= 0);
		}
		if (contains(1, 2, 3))
			return ['3'];
		else if (contains(1, 2, 4))
			return ['4'];
		else if (contains(1, 2, 5))
			return ['1', '2'];
		else if (contains(1, 3, 4))
			return ['4'];
		else if (contains(1, 3, 5))
			return ['3'];
		else if (contains(2, 3, 4))
			return ['4'];
		else if (contains(2, 3, 5))
			return ['3'];
		else if (contains(1, 2))
			return ['1', '2'];
		else if (contains(1, 3))
			return ['3'];
		else if (contains(1, 4))
			return ['4'];
		else if (contains(1, 5))
			return ['1'];
		else if (contains(2, 3))
			return ['3'];
		else if (contains(2, 4))
			return ['4'];
		else if (contains(2, 5))
			return ['2'];
		else if (contains(3, 4))
			return ['4'];
		else if (contains(3, 5))
			return ['3'];
		else if (contains(4, 5))
			return ['4'];
		else if (contains(1))
			return ['1'];
		else if (contains(2))
			return ['2'];
		else if (contains(5))
			return ['5'];

		return values;
	}

	calcReasons() {
		console.log("run calcReasons");
		var _this = this;
		if (document.querySelectorAll("div[data-reasonid='4']").length > 0) {
			document.querySelectorAll("div[data-id*='_glcontainer']").forEach(function (div) {
				while (div.firstChild)
					div.removeChild(div.lastChild);

				var id = div.getAttribute("data-id");
				var rid = id.replace("glcontainer", "r_");
				if (document.querySelectorAll("div[data-id*='" + rid + "']") != null && document.querySelectorAll("div[data-id*='" + rid + "']").length > 0) {
					var r = document.createElement("div");
					r.classList.add("archdatareasoncol", "archdatareasoncol_4");
					r.innerHTML = 4;
					div.appendChild(r);
				}


			});
		}
		else if (document.querySelectorAll("div[data-reasonid='3']").length > 0) {
			document.querySelectorAll("div[data-id*='_glcontainer']").forEach(function (div) {
				while (div.firstChild)
					div.removeChild(div.lastChild);
				var id = div.getAttribute("data-id");
				var rid = id.replace("glcontainer", "r_");
				if (document.querySelectorAll("div[data-id*='" + rid + "']") != null && document.querySelectorAll("div[data-id*='" + rid + "']").length > 0) {
					var r = document.createElement("div");
					r.classList.add("archdatareasoncol", "archdatareasoncol_3");
					r.innerHTML = 3;
					div.appendChild(r);
				}
			});
		}
		else {
			document.querySelectorAll("div[data-id*='_glcontainer']").forEach(function (div) {
				while (div.firstChild)
					div.removeChild(div.lastChild);
				var id = div.getAttribute("data-id");
				var rid = id.replace("glcontainer", "r_");
				let ar = new Array();
				document.querySelectorAll("div[data-id*='" + rid + "']").forEach(function (rc) {

					if (ar.indexOf(rc.innerHTML) < 0)
						ar.push(rc.innerHTML);
				});

				if (ar.length > 0) {
					var reasons = _this.getReasons(ar);
					for (var i = 0; i < reasons.length; i++) {
						var r1 = document.createElement("div");
						r1.classList.add("archdatareasoncol", "archdatareasoncol_" + reasons[i]);
						r1.innerHTML = reasons[i];
						div.appendChild(r1);
					}
				}
			});
		}
	}
}
Tango.registerComponent(archdatadiff_aupcompare_section, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));